import BankCalendarFormHandle from '../../containers/formHandlers/bank/BankCalendarFormUI/BankCalendarFormHandle';

export default function Calendar() {
  return (
    <>
      <BankCalendarFormHandle />
    </>
  );
}
